export default "__VITE_ASSET__eb7f2aaf__"